import React from "react";
import { Box, FormControlLabel, Grid, IconButton, MenuItem, Stack, Switch, TextField, Tooltip, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import _ from "lodash";
import { TextAddButton } from "./AutomationMetaHeader";

export const CHANNEL_LABELS = { email: "Correo", whatsapp: "WhatsApp", slack: "Slack" };

// A quién avisar y por qué canal, igual que el «Entonces» de las reglas. Lo comparten los tipos de control (mantener en
// rango, límites de seguridad). `channels` trae la disponibilidad de cada canal: un canal no disponible se ve con su
// razón (por ejemplo, la plantilla de WhatsApp todavía sin aprobar) pero no se puede elegir.
const RecipientsEditor = ({ recipients = [], onChange, users = [], channels = [], emptyText = "Nadie recibe avisos todavía." }) => {
    const usersById = _.keyBy(users, "id");
    const defaultChannel = _.find(channels, "available")?.key || "email";
    const unavailable = _.filter(channels, (channel) => !channel.available);

    const update = (index, patch) => onChange(recipients.map((recipient, position) => (position === index ? { ...recipient, ...patch } : recipient)));
    const remove = (index) => onChange(recipients.filter((_recipient, position) => position !== index));
    const add = () => onChange([...recipients, { user_id: users[0]?.id || "", channel: defaultChannel, enabled: true }]);

    return (
        <Stack spacing={0}>
            {recipients.map((recipient, index) => {
                const user = usersById[recipient.user_id];
                const missingPhone = recipient.channel === "whatsapp" && user && !user.phone;
                return (
                    <Box
                        key={`recipient-${recipient.id || index}`}
                        sx={{ py: 1.25, borderBottom: index < recipients.length - 1 ? "1px solid" : "none", borderColor: "divider" }}>
                        <Grid container spacing={1.5} alignItems="center">
                            <Grid item xs={12} md={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Usuario"
                                    value={recipient.user_id || ""}
                                    onChange={(event) => update(index, { user_id: event.target.value })}>
                                    {users.map((option) => (
                                        <MenuItem key={`recipient-user-${option.id}`} value={option.id}>
                                            {option.full_name || option.email}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Canal"
                                    value={recipient.channel || defaultChannel}
                                    onChange={(event) => update(index, { channel: event.target.value })}
                                    error={missingPhone}
                                    helperText={missingPhone ? "Este usuario no tiene teléfono registrado" : undefined}>
                                    {channels.map((channel) => (
                                        <MenuItem key={`recipient-channel-${channel.key}`} value={channel.key} disabled={!channel.available}>
                                            {CHANNEL_LABELS[channel.key] || channel.key}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={8} md={1}>
                                <FormControlLabel
                                    sx={{ ml: 0 }}
                                    label=""
                                    control={<Switch checked={recipient.enabled !== false} onChange={(event) => update(index, { enabled: event.target.checked })} />}
                                />
                            </Grid>
                            <Grid item xs={4} md={1} textAlign="right">
                                <Tooltip title="Eliminar destinatario">
                                    <IconButton color="error" onClick={() => remove(index)}>
                                        <DeleteOutlineOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                );
            })}
            {!recipients.length && <Typography variant="body2" color="text.secondary" sx={{ pb: 0.5 }}>{emptyText}</Typography>}
            <TextAddButton onClick={add}>Agregar destinatario</TextAddButton>
            {unavailable.map((channel) => (
                <Typography key={`channel-note-${channel.key}`} variant="caption" color="text.secondary">
                    {CHANNEL_LABELS[channel.key] || channel.key}: {channel.unavailable_reason}
                </Typography>
            ))}
        </Stack>
    );
};

export default RecipientsEditor;
